import React, { useLayoutEffect } from 'react';
import Logo from '../../images/logo.svg?react';
import { Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';
import { setSplashColor } from 'src/shared/utils/splashColor';
import { Style } from '@capacitor/status-bar';

export const AppLoader = () => {
  const { t } = useTranslation('auth');

  useLayoutEffect(() => {
    setSplashColor('#0288d1', Style.Dark);
  }, []);

  return (
    <div className={'flex flex-col gap-2.5 items-center justify-center w-screen h-screen bg-app'}>
      <Logo />
      <Typography variant={TypographyVariantsEnum.Text14Regular} className={'text-color-white'}>
        {t('splash.screen.text')}
      </Typography>
    </div>
  );
};
